import { Box, Flex, StyleProps, Text, chakra } from "@chakra-ui/react";
import { TagRow } from "./type";
import { useMemo } from "react";
import BadgeTooltip from "@components/Tooltip/BadgeTooltip";
import BaseImage from "@components/BaseImage";
import { getImgSrcFromStorage } from "@components/StorageImage";

const BADGE_BG_COLOR = "#EBF8FF";
const BADGE_BG_COLOR_FEATURED = "#D8F0F0";
const BADGE_TEXT_COLOR = "#075A5A";
interface Props {
  allTags: TagRow[];
  tags: string;
  tagWithImage?: string;
  tagImagePath?: string;
  featuredDefi?: boolean;
}

const DeFiTag = ({
  tag,
  featuredDefi = false,
  style,
}: {
  tag: string;
  featuredDefi?: boolean;
  style?: StyleProps;
}) => {
  return (
    <chakra.div
      bg={`${featuredDefi ? BADGE_BG_COLOR_FEATURED : BADGE_BG_COLOR}`}
      textColor={BADGE_TEXT_COLOR}
      borderRadius={4}
      paddingX={2}
      paddingY={2}
      fontSize={10}
      fontWeight="bold"
      lineHeight={1}
      flex={1}
      {...(style || {})}
    >
      {tag}
    </chakra.div>
  );
};

const DefiRowTags = ({
  tags,
  tagWithImage,
  tagImagePath,
  featuredDefi = false,
}: Props) => {
  const tagItems = useMemo(() => {
    return tags
      .split(",")
      .map((tag) => tag.trim())
      .filter((tag) => tag !== "");
  }, [tags]);

  const maxTags = featuredDefi ? 2 : 1;
  const conditionalProps = featuredDefi ? {} : { flex: 1 };

  return (
    <Flex>
      <Flex gap={1} direction={"column"}>
        <Flex gap={1}>
          {tagItems.length > 0 && tagItems[0] != "" && (
            <Flex {...conditionalProps}>
              <DeFiTag
                key={tagItems[0]}
                tag={tagItems[0]}
                featuredDefi={featuredDefi}
              />
            </Flex>
          )}
          {featuredDefi && tagItems.length > 1 && (
            <Flex {...conditionalProps}>
              <DeFiTag key={tagItems[1]} tag={tagItems[1]} featuredDefi />
            </Flex>
          )}

          {tagItems.length > maxTags && (
            <BadgeTooltip
              label={`+${tagItems.length - maxTags}`}
              bgColor={featuredDefi ? BADGE_BG_COLOR_FEATURED : BADGE_BG_COLOR}
              contentBgColor={"backgroundCard"}
              textColor={BADGE_TEXT_COLOR}
              content={
                <Box minWidth={200} maxWidth={300} px={5} py={2}>
                  <Text fontSize={16} fontWeight={600} px={0} mb={2}>
                    Benefits
                  </Text>
                  <chakra.ul px={4}>
                    {tagItems.map((tag) => {
                      return <li key={tag}>{tag}</li>;
                    })}
                  </chakra.ul>
                </Box>
              }
            />
          )}
        </Flex>
        {!featuredDefi && tagWithImage && tagImagePath && (
          <Flex
            alignItems={"center"}
            borderRadius={4}
            bgColor={featuredDefi ? BADGE_BG_COLOR_FEATURED : BADGE_BG_COLOR}
          >
            <Flex pl="1.5" alignItems={"center"} borderRadius={"50%"}>
              <BaseImage
                width={18}
                height={18}
                src={getImgSrcFromStorage(tagImagePath)}
                alt=""
              />
            </Flex>
            <DeFiTag
              key={tagItems[0]}
              tag={tagWithImage}
              style={{ pl: 1, pr: 2 }}
            />
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default DefiRowTags;
